// DeleteDialog.jsx

import React from 'react';
import { Dialog, DialogContent, DialogActions, Button, DialogTitle } from '@mui/material';

const DeleteDialog = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      style={{
        backdropFilter: 'blur(5px)',
        borderRadius: '40px'
      }}
    >
      <DialogTitle>Delete Confirmation</DialogTitle>
      <DialogContent>Are you sure you want to delete this item?</DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" style={{ color: '#66b5a3' }}>
          Cancel
        </Button>
        <Button onClick={onConfirm} color="error">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog;
